export default "/Frontend/dist/word-hover.62ccf5d9d9fa6d5b5d18bdedf3fcf7e7.svg";